module.exports = __webpack_public_path__ + "img/ИФ-1(А)-046-m.7f37a76b.png";